import { Progress } from './Progress';

export const components = {
  Progress,
};
